<!-- =========================================================================================
    File Name: ForgotPassword.vue
    Description: FOrgot Password Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuesax Admin - VueJS Dashboard Admin Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
    <div class="h-screen flex w-full bg-img">
        <div class="vx-col w-4/5 sm:w-4/5 md:w-3/5 lg:w-3/4 xl:w-3/5 mx-auto self-center">
            <vx-card>
                <div slot="no-body" class="full-page-bg-color">
                    <div class="vx-row">
                        <div class="vx-col hidden sm:hidden md:hidden lg:block lg:w-1/2 mx-auto self-center">
                            <img src="@/assets/images/pages/forgot-password.png" alt="login" class="mx-auto">
                        </div>
                        <div class="vx-col sm:w-full md:w-full lg:w-1/2 mx-auto self-center  d-theme-dark-bg">
                            <div class="p-8">
                                <div class="vx-card__title mb-8">
                                    <h4 class="mb-4">Recuperar Senha</h4>
                                    <p>Digite o seu login para enviarmos a senha via email.</p>
                                </div>

                                <vs-input type="tex" label-placeholder="Login" v-model="value1" class="w-full mb-8" />
                                <vs-button type="border" to="/pages/login" class="px-4 w-full md:w-auto">Acessar Conta</vs-button>
                                <vs-button class="float-right px-4 w-full md:w-auto mt-3 mb-8 md:mt-0 md:mb-0" @click="recuperarsenha">Recuperar Senha</vs-button>
                            </div>
                        </div>
                    </div>
                </div>
            </vx-card>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            value1: ''
        }
    },
	methods: {
		recuperarsenha()
		{
			this.$vs.loading({
				type:'radius',
			})

			fetch(this.$store.state.API_URL + 'Info/New/Password', {
				method: 'POST',
				headers: { 'Accept': 'application/json', 'Content-Type': 'application/x-www-form-urlencoded' },
				body: "username="+this.value1
			})
			.then((response) => response.text())
			.then((responseData) => {
				var dados = JSON.parse(responseData);
				if(dados.done == true)
				{
					setTimeout( ()=> {
						this.$vs.loading.close();
						this.$vs.notify({
							title: 'UzePay',
							text: dados.message,
							iconPack: 'feather',
							icon: 'icon-alert-circle',
							color: 'success'
						});
					}, 4000);

				}
				else
				{	
					setTimeout( ()=> {
						this.$vs.loading.close();
						this.$vs.notify({
							title: 'UzePay',
							text: dados.message,
							iconPack: 'feather',
							icon: 'icon-alert-circle',
							color: 'warning'
						});

					}, 4000);
				}
				
			})
			.catch((error) => {
				setTimeout( ()=> {
						this.$vs.loading.close();
						this.$vs.notify({
							title: 'UzePay',
							text: error,
							iconPack: 'feather',
							icon: 'icon-alert-circle',
							color: 'warning'
						});

				}, 4000);
			});
		},

	}
}
</script>
